const validatePin = (pin) => {
  if (/^\d{4}$/.test(pin)) {
    return true;
  }
  return false;
};

export default validatePin;
